import type { States } from '../states';

import type { MultiLangState } from './state';

export const selectMultiLang = ({ MultiLang }: States): MultiLangState => MultiLang;
